import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { DashboardFiltersState } from '../../models';

@Injectable()
export class DashboardFiltersService {
  private readonly filtersMap = new BehaviorSubject<Record<string, DashboardFiltersState>>({});

  setDashboardFilters(filterState: DashboardFiltersState): void {
    const currentMap = this.filtersMap.value;
    this.filtersMap.next({
      ...currentMap,
      [filterState.dashboardId]: filterState,
    });
  }

  getDashboardFilters(dashboardId: string): Observable<DashboardFiltersState> {
    return this.filtersMap.pipe(map((filtersMap) => filtersMap[dashboardId]));
  }
}
